import { render, staticRenderFns } from "./TourGroup.vue?vue&type=template&id=23a068bc&scoped=true&"
import script from "./TourGroup.vue?vue&type=script&lang=js&"
export * from "./TourGroup.vue?vue&type=script&lang=js&"
import style0 from "./TourGroup.vue?vue&type=style&index=0&id=23a068bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a068bc",
  null
  
)

export default component.exports